import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1919.88508,1468.30298 L1919.88508,1583.22143 L81.3048032,1583.22143 L81.3048032,1468.30298 L1919.88508,1468.30298 Z M1919.88508,1123.54763 L1919.88508,1238.46608 L81.3048032,1238.46608 L81.3048032,1123.54763 L1919.88508,1123.54763 Z M1920,778.792279 L1920,893.710729 L885.733952,893.710729 L885.733952,778.792279 L1920,778.792279 Z M270.518031,336 L351.765375,417.132426 L220.068831,548.943887 L713.413736,548.943887 L713.413736,663.862337 L220.068831,663.862337 L351.765375,795.673799 L270.518031,876.921143 L1.13686838e-13,606.518031 L270.518031,336 Z M1920,434.03693 L1920,548.955379 L885.733952,548.955379 L885.733952,434.03693 L1920,434.03693 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconOutdent2Line = /*#__PURE__*/function (_Component) {
  _inherits(IconOutdent2Line, _Component);

  var _super = _createSuper(IconOutdent2Line);

  function IconOutdent2Line() {
    _classCallCheck(this, IconOutdent2Line);

    return _super.apply(this, arguments);
  }

  _createClass(IconOutdent2Line, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconOutdent2",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconOutdent2Line.displayName = "IconOutdent2Line";
  return IconOutdent2Line;
}(Component);

IconOutdent2Line.glyphName = 'outdent2';
IconOutdent2Line.variant = 'Line';
IconOutdent2Line.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconOutdent2Line;
export { IconOutdent2Line };